module.exports = __webpack_public_path__ + "assets/img/free_18.4dff133b.png";